import React, { useEffect, useRef, useState } from 'react'
import LegalTerms from '../../../templates/components/legal-terms.html'

const EXPORT_FORMATS = [
  { type: 'PDF', 
    label: 'PDF (.pdf)'
  }, 
  { type: 'JSON',
    label: 'JSON (.json)'
  },
  { type: 'CSV-BOM',
    label: 'Comma separated values (.csv), Excel-compatible'
  },
  { type: 'CSV',
    label: 'Comma separated values (.csv)'
  }

]

const ExportModal = ({ showModal, exporting, handleExport, cancel }) => {
  // UI state
  const [showImagesTab, setShowImagesTab] = useState(false)

  // Export options
  const [dataOptions, setDataOptions] = useState({})
  const [format, setFormat] = useState('PDF')
  const [imageSizeOption, setImageSizeOption] = useState()
  const [imageTermsAgreed, setImageTermsAgreed] = useState(false)
  const [canExport, setCanExport] = useState(true)

  const dataOptionsFields = useRef(null)
  const formatsElement = useRef(null)
  const imageOptionsFields = useRef(null)

  useEffect(() => {
    setCanExport(!imageSizeOption || imageSizeOption === 'small' || imageSizeOption === 'large' && imageTermsAgreed)
  }, [imageSizeOption, imageTermsAgreed])

  const toggleImagesTab = (event) => {
    event.preventDefault()

    setShowImagesTab(!showImagesTab)
  }

  const onImageTermsClicked = (event) => {
    setImageTermsAgreed(!imageTermsAgreed)
  }

  const onExportClick = () => {
    const format = formatsElement.current.value
    const images = imageSizeOption ? { size: imageSizeOption } : {}

    const options = {
      data: dataOptions,
      images,
      format
    }

    handleExport(format, options)
  }

  const onInputClick = (event) => {
    const dataOption = event.target.dataset.option
    const imageOption = event.target.dataset.imageOption

    const aboutOptions = { about: true, titleDate: true, remarks: true, materials: true, exhibitions: true, references: true, provenance: true }
    switch (true) {
      case (dataOption === 'about'):
        // Toggle all the options, depending on whether about is already set
        const toggled = dataOptions.about ? {} : { ...aboutOptions }
        setDataOptions({ ...toggled, conservation: dataOptions.conservation })
        break

      case (dataOption === 'conservation'):
        setDataOptions({ ...dataOptions, conservation: !dataOptions.conservation })
        break

      case (dataOption !== undefined && dataOption !== 'conservation'):
        // If not all of the keys are set, unset about
        let about = true
        for (const key in aboutOptions) {
          if (key === 'about') continue

          if (key === dataOption && dataOptions[key] === true) {
            about = false
            continue
          } 

          if (key === dataOption) continue

          if (dataOptions[key] === false) {
            about = false
            continue
          }

          if (!(key in dataOptions)) {
            about = false
            continue
          }
        }

        setDataOptions({ ...dataOptions, [dataOption]: !dataOptions[dataOption], about })
        break

      // If there is already an image option, toggle or unset
      case (imageOption === 'large-image' && imageSizeOption === 'large'
          || imageOption === 'small-image' && imageSizeOption === 'small'):
        setImageSizeOption(undefined)
        break

      case (imageOption !== undefined):
        setImageSizeOption(imageOption === 'small-image' ? 'small' : 'large')
        break
    }
  }

  const onChangeFormat = (event) => {
    setFormat(event.target.value)
  }

  return <div id="export-modal" className={`modal ${ showModal ? 'is-active' : ''}`}>
          <div className="modal-background"></div>
          <div className="modal-card">
            <div className={`${exporting ? 'loading-image' : 'is-hidden'} modal-card-progress-indicator`} ></div>
            <header className="modal-card-head">
              <h1 className="modal-card-title">
                EXPORT LIST</h1>
              <button onClick={cancel} className="btn-icon-only icon-lg btn-close" aria-label="close">
                <span className="icon icon-close-large"></span><span className="sr-only">Close this
                  dialog</span>
              </button>
            </header>
            <section className="modal-card-body min-height-large-container is-relative">
              <div>
                <div className="tabs is-boxed">
                  <ul>
                    <li className={`${ showImagesTab ? '' : 'is-active active-tab' } has-text-weight-semibold`}>
                      <a onClick={toggleImagesTab} role="heading" aria-level="2" data-target="data-tab"><span>Data</span></a>
                    </li>
                    <li className={`${ showImagesTab ? 'is-active active-tab' : '' } has-text-weight-semibold`}>
                      <a onClick={toggleImagesTab} role="heading" aria-level="2" data-target="image-tab"><span>Images</span></a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className={`tab-content ${ showImagesTab ? 'is-hidden' : '' }`} id="data-tab">
                <div className="my-3">
                  <label className="checkbox single-checkbox ">
                    <input type="checkbox" checked disabled className="custom-checkbox" />
                    Basic object information
                  </label>
                </div>
                <fieldset ref={dataOptionsFields}>
                  <legend>Additional information for O’Keeffe artwork:</legend>
                  <ul className="my-3">
                    <li>
                      <label className="checkbox single-checkbox ">
                        <input onClick={onInputClick} data-option="about" checked={dataOptions.about} type="checkbox" className="custom-checkbox" />
                        About
                      </label>
                      <fieldset className="custom-fieldset">
                        <label className="checkbox single-checkbox">
                          <input onClick={onInputClick} type="checkbox" data-option="titleDate" checked={dataOptions.titleDate} className="custom-checkbox"/>
                          Title and Date Details
                        </label>
                        <label className="checkbox single-checkbox">
                          <input onClick={onInputClick} type="checkbox" data-option="materials" checked={dataOptions.materials} className="custom-checkbox" />
                          Materials
                        </label>
                        <label className="checkbox single-checkbox">
                          <input onClick={onInputClick} type="checkbox" data-option="references" checked={dataOptions.references} className="custom-checkbox" />
                          Selected References
                        </label>
                        <label className="checkbox single-checkbox">
                          <input onClick={onInputClick} type="checkbox" data-option="remarks" checked={dataOptions.remarks} className="custom-checkbox" />
                          Remarks & Inscriptions
                        </label>
                        <label className="checkbox single-checkbox">
                          <input onClick={onInputClick} type="checkbox" data-option="exhibitions" checked={dataOptions.exhibitions} className="custom-checkbox" />
                          Exhibition History
                        </label>
                        <label className="checkbox single-checkbox">
                          <input onClick={onInputClick} type="checkbox" data-option="provenance" checked={dataOptions.provenance} className="custom-checkbox" />
                          Provenance
                        </label>
                      </fieldset>
                    </li>
                    <li>
                      <label className="checkbox single-checkbox ">
                        <input onClick={onInputClick} type="checkbox" data-option="conservation" checked={dataOptions.conservation} className="custom-checkbox" />
                        Conservation
                      </label>
                    </li>
                  </ul>
                  <div className="columns">
                    <div className="column is-three-quarters-mobile is-two-thirds-tablet is-half-desktop">
                      <div className="field">
                        <label className="label">Format:</label>
                        <div className="control">
                          <div className="custom-select">
                            <select id="listSelect" ref={formatsElement} onChange={onChangeFormat} defaultValue={format}>
                              <button>
                                <selectedcontent></selectedcontent>
                              </button>
                              {
                                EXPORT_FORMATS.map((fmt, i) => <option key={i} value={fmt.type}>{fmt.label}</option> )
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`column ${imageSizeOption === undefined ? 'is-hidden' : ''}`}>
                      <div>
                        <span className='is-size-7'>If images are selected for download, all images and data will be contained in a .zip file.</span>                      
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div className={`tab-content ${ showImagesTab ? '' : 'is-hidden' }`}  id="image-tab">
                <fieldset className="custom-fieldset two-column" ref={imageOptionsFields}>
                  <label className="checkbox single-checkbox">
                    <input checked={imageSizeOption === 'small'} onChange={onInputClick} data-image-option="small-image" type="checkbox" className="custom-checkbox" />
                    Small thumbnail image
                  </label>

                  <label className="checkbox single-checkbox">
                    <input checked={imageSizeOption === 'large'} onChange={onInputClick} data-image-option="large-image" type="checkbox" className="custom-checkbox" />
                    Large image (if available)
                  </label>
                </fieldset>
              </div>
                <div className={ imageSizeOption === 'large' && showImagesTab ? '' : 'is-hidden'}>
                  <div dangerouslySetInnerHTML={{ __html: LegalTerms }} />
                  <div className="mt-3">
                    <label className="checkbox single-checkbox">
                      <input onClick={onImageTermsClicked}
                             checked={imageTermsAgreed}
                             className="custom-checkbox" type="checkbox" id="legal-modal-terms-checkbox" />
                      I have read and accept the Terms of Use for educational or non-commercial uses
                    </label>
                  </div>
                </div>
              <div className={ imageSizeOption === 'large' && showImagesTab ? '' : 'is-hidden' }>
                <a className="btn-text px-0" href="https://www.okeeffemuseum.org/rights-and-reproductions/" target="_blank">
                  <span className="icon icon-share"></span>
                  Learn about commercial use
                </a>
              </div>
              </section>
            <footer className="modal-card-foot">
              <div className="is-flex ml-auto">
                <button className="button" onClick={cancel} >Cancel</button>
                <button className="btn-solid" disabled={!canExport} onClick={onExportClick}>Export</button>
              </div>
            </footer>
          </div>
        </div>
}

export default ExportModal